import { render } from "./promotions_list.vue?vue&type=template&id=74a8a135&scoped=true"
import script from "./promotions_list.vue?vue&type=script&lang=js"
export * from "./promotions_list.vue?vue&type=script&lang=js"

import "./promotions_list.vue?vue&type=style&index=0&id=74a8a135&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a8a135"]])

export default __exports__